import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'

import { ToastContainer, toast } from 'react-toastify';

const TecCompanyMain = () => {

  useEffect(()=>{

    document.getElementById('tec-sectionMain').style.display = "none";
   
  setTimeout(()=>{
    document.getElementById('tec-lableMainA').style.position="static"  
    // document.getElementById('tec-lableMainB').style.position="static"
    document.getElementById('tec-lableMainC').style.position="static"  
    document.getElementById('tec-lableMainD').style.position="static" 
    document.getElementById('tec-lableMainE').style.position="static" 
 
    document.getElementById('tec-sectionMain').style.display = "block";
    



  },1000)
},[])
  return (
    <div className='tec-addmain'>
      
      
    <ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 
         <div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain">COMPANY</span></span>
 <div className='tec-addmain-back'>
<Link to="/Tecsection"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
</div></p> 

 {/* <hr></hr> */}
 </div>
    </div>    


    <ul id="tecLableSection">
  <li className="tecdot tecdottyCompany1"id="tec-lableMainA"></li>
  {/* <li className="tecdot tecdottyCompany2" id="tec-lableMainB"></li> */}
  <li className="tecdot tecdottyCompany3" id="tec-lableMainC"></li>
  <li className="tecdot tecdottyCompany4" id="tec-lableMainD"></li>
  <li className="tecdot tecdottyCompany5" id="tec-lableMainE"></li>
  </ul>
  <ul id='tec-sectionMain'>

<li className='tectitle1 tectitle-animate' id="tec-touchMainA"><Link to="/TecAbout">About</Link></li>
{/* <li className='tectitle2 tectitle-animate'  id="tec-touchMainB"><Link to="/TecLeaders">Team</Link></li> */}
<li className='tectitle3 tectitle-animate'  id="tec-touchMainC"><Link to="/TecLife">Life here</Link></li>
<li className='tectitle4 tectitle-animate'  id="tec-touchMainD"><Link to="/TecGiving">Giving back</Link></li>
<li className='tectitle5 tectitle-animate'  id="tec-touchMainE"><Link to="/TecCareers">Careers</Link></li>



 </ul>
   
     <div>
    
  
        </div>
  


        </div>
  )
}

export default TecCompanyMain
